import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

// Axios Request
import { fetchSinglePost } from '../requests/singlepost_request';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Loader from '../components/Loader';

import RenderContact from '../components/Pages/RenderContact';

import { setDefaultProps } from 'react-on-visible';

setDefaultProps({
    bounce: true,
    visibleClassName: 'appear',
    percent: 10,
});

class SinglePageContact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            test: false,
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentWillMount() {
        this.getPosts(this.props, true);
    }

    componentWillReceiveProps(nextProps) {
        this.getPosts(nextProps);
    }

    getPosts(props, willMount = false) {
        let slug = this.props.match.path;
        slug = slug.substring(1);
        if (willMount) {
            this.props.fetchSinglePost('pages', slug);
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.posts.fetched) {
            document.title = `${nextProps.posts.posts[0].title.rendered} - Friends for Brands`;
        }
    }

    render() {
        let url;
        if (this.props.posts.fetched) {
            url = `/${this.props.posts.posts[0].slug}/`;
        }

        return (
            <div className="single contact">
                <Header />
                <main>
                    <div id="main-container">
                        <div className="content-container">
                            <Loader loaded={this.props.posts.fetched} />
                            {url === this.props.match.url && (
                                <div className="fadeIn">
                                    <RenderContact
                                        posts={this.props.posts}
                                        contact={true}
                                    />
                                </div>
                            )}
                        </div>
                        <br />
                        <br />
                        <br />
                        {/* <div className="null-margin">
                            <OnVisible>
                                <div className="banner-container">
                                    <FPBanner
                                        title="OR APP US DIRECTLY ON THE FRIENDS PHONE"
                                        text="WE LOVE IT."
                                    />
                                </div>
                            </OnVisible>
                        </div> */}
                    </div>
                    <Footer type="contact" />
                </main>
            </div>
        );
    }
}

function mapStateToProps({ posts }) {
    return { posts };
}

export default withRouter(
    connect(mapStateToProps, { fetchSinglePost })(SinglePageContact)
);



// WEBPACK FOOTER //
// ./src/containers/SinglePageContact.jsx